const AD_FLOW_NAMES = {
    SUCCESS_FLOW: 'SUCCESS_FLOW',
    MARKET_FLOW: 'MARKET_FLOW',
    FWU_CHECK_AND_RESET_FLOW: 'FWU_CHECK_AND_RESET_FLOW',
    FWU_CHECK_AND_MARKET_FLOW: 'FWU_CHECK_AND_MARKET_FLOW',
    FWU_CHECK_AND_ADAPTOR_MSG_FLOW: 'FWU_CHECK_AND_ADAPTOR_MSG_FLOW',
};

export default AD_FLOW_NAMES;
